
$(document).ready(function() {

  var items = $('.imperiya-notification__item');
  if(items.length > 1) {
      var current = 0;
      setInterval(function(){
          var next = (current + 1) % items.length;
          $(items[current]).fadeOut(600, function(){
              $(items[next]).fadeIn(600);
          });
          current = next;
      }, 5000);
  } else {
      $(items).fadeIn(600);
  }
});